import { UserRole } from 'susy-common/models';

export enum UserRoleActionType {
    GET_ALL_USER_ROLES = 'GET_ALL_USER_ROLES',
}

export interface UserRolesAction {
    type: UserRoleActionType;
    payload: Array<UserRole>;
}

